import React, { useEffect, useState } from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  ListGroup,
  ListGroupItem,
  Spinner,
} from "reactstrap";

const AlarmList = ({
  selectedDate,
  selectedShift,
  selectedMachine,
}) => {
  const [alarms, setAlarms] = useState([]);
  const [loading, setLoading] = useState(true);

  const transformAlarmData = (apiResponse) => {
    return apiResponse.results.flatMap(item =>
      item.alarms.map(alarm => ({
        // id: item.alarm_log_id,
        date: item.date,
        time: item.time,
        station: item.station,
        description: alarm.description,
      }))
    );
  };
  const exportToExcel = () => {
    if (!alarms.length) return;

    const worksheet = XLSX.utils.json_to_sheet(alarms);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Alarms");

    const fileName = `Alarms_${selectedMachine}_${selectedDate}_Shift${selectedShift}.xlsx`;
    XLSX.writeFile(workbook, fileName);
  };
  useEffect(() => {
    let intervalId;

    const fetchAlarms = async () => {
      try {
        const res = await axios.get(
          `https://api.hanoch.in/api/mcc/latest-resolve-alarm/?machine_id=${selectedMachine}&date=${selectedDate}&shift=${selectedShift}`
        );

        const formatted = transformAlarmData(res);
        setAlarms(formatted);
      } catch (err) {
        console.error("Alarm fetch error:", err);
      } finally {
        setLoading(false);
      }
    };

    // 🔹 Initial fetch
    fetchAlarms();

    // 🔁 Fetch every 1 minute
    intervalId = setInterval(fetchAlarms, 60000);

    // 🧹 Cleanup on unmount
    return () => clearInterval(intervalId);
  }, []);

  if (loading) return <Spinner />;

  return (
    <Card>
      <CardHeader className="d-flex justify-content-between align-items-center">
        <strong>Latest Alarms</strong>

        <Button
          size="sm"
          color="success"
          onClick={exportToExcel}
          disabled={!alarms.length}
        >
          Export Excel
        </Button>
      </CardHeader>


      <CardBody style={{ maxHeight: "500px", overflowY: "auto" }}>
        <ListGroup flush>
          {alarms.map((alarm, index) => (
            <ListGroupItem key={`${alarm.id}-${index}`}>
              <div className="d-flex justify-content-between">
                <div>
                  <strong className="fs-5">{alarm.station}</strong>
                  {" — "}
                  {alarm.description}
                </div>
                <div className="text-muted text-end">
                  <div>{alarm.date}</div>
                  <small><b>{alarm.time}</b></small>
                </div>
              </div>
            </ListGroupItem>
          ))}
        </ListGroup>
      </CardBody>
    </Card>
  );
};

export default AlarmList;
